import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddManager = () => {
  const navigate=useNavigate()
  const [choice, setChoice] = useState("existing");
  const [users, setUsers] = useState([]); 
  const [selectedUser, setSelectedUser] = useState("");
  const [loading,setLoading]=useState(false)


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/marketplace/university/user-profiles/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        // console.log("Users API Response:", res.data);

        // ✅ handle paginated OR normal response
        setUsers(res.data.results || res.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);

  const handleAddDean = async (e) => {
    e.preventDefault()
    if(!selectedUser) return alert('Profile id is requried')
    try {
      setLoading(true)
      await axios.post(
        `${BASE_URL}/marketplace/industry/manager/`,
        {
          profile_id: selectedUser, 
        //   department_id:depId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );

      // console.log("Dean Created:", res.data);
      alert("Industry Manager created successfully");
      navigate(`/marketplace/industry/managers`)
      setSelectedUser("");
    } catch (error) {
      alert(error.response?.data?.error);
      console.log("Error while creating dean", error?.response);
    }finally{
      setLoading(false)
    }
  };

  return (
    <>
     {/* Buttons */}
<div className="flex items-center justify-center gap-4 mb-6">
  <button
    type="button"
    onClick={() => setChoice("existing")}
    className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
      choice === "existing"
        ? "bg-[#0f6abf] text-white shadow-sm"
        : "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
    }`}
  >
    Select Manager From Existing Users
  </button>

  <button
    type="button"
    onClick={() => setChoice("manual")}
    className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
      choice === "manual"
        ? "bg-[#0f6abf] text-white shadow-sm"
        : "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
    }`}
  >
    Add Manager User Manually
  </button>
</div>

{/* Existing User Selection */}
{choice === "existing" && (
  <form
    onSubmit={handleAddDean}
    className="bg-white rounded-2xl border border-gray-200 p-6 max-w-3xl mx-auto"
  >
  

    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Select Manager
        </label>
      </div>

      <select
        value={selectedUser}
        onChange={(e) => setSelectedUser(e.target.value)}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl"
        required
      >
        <option value="">-- Select Manager --</option>

        {users.map((user) => (
          <option
            key={user.profile_id || user.id}
            value={user.profile_id || user.id}
          >
            {user.name || user.full_name} ({user.email})
          </option>
        ))}
      </select>
    </div>

    <button
      type="submit"
      disabled={loading}
      className="mt-6 w-full bg-[#0f6abf] text-white py-3 rounded-xl"
    >
      {loading ? "Creating Manager..." : "Add Manager"}
    </button>
  </form>
)}


      {choice === "manual" && <></>}
    </>
  );
};

export default AddManager;
